/**
 * @module App
 * @description This is the entry point for the application.
 */
import ReactDOM from 'react-dom/client';
import { CssBaseline } from '@mui/material';
import { AppWithProviders } from 'src/app/provider';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <>
    <CssBaseline />
    <AppWithProviders />
  </>,
);
